<script setup lang="ts">
import type { CmsElementBioCircle } from "~/composables/useCustom";
import SharedHeadline from "~/components/shared/SharedHeadline.vue";
import SharedTopline from "~/components/shared/SharedTopline.vue";

const props = defineProps<{
  content: CmsElementBioCircle;
}>();

const { headlineText, headlineType, backgroundImage } = props.content.data

</script>
<template>


  <section class="relative min-h-[380px] max-h-[380px] flex overflow-hidden">
    <NuxtImg format="webp" loading="lazy" v-if="backgroundImage && backgroundImage.media" :src="backgroundImage.media.url" alt="" class="-mt-8 w-full object-cover" height="380px" />
    <div class="w-full absolute top-1/2 -translate-y-1/2 left-0 text-center text-skin-white">
      <div class="container">
        <SharedHeadline :headline="headlineText" :headlineType="headlineType" class="text-skin-white uppercase"></SharedHeadline>
      </div>
    </div>
  </section>
</template>
